import { Injectable } from '@angular/core';
import { CheckableRowsService } from './checkable-rows.service';

@Injectable()
export class CheckableRowsServiceFactory {
    public create(): CheckableRowsService {
        return new CheckableRowsService();
    }
}
